<template>
    <div>
        <div class="holder">
            <h2 id="page-header"><router-link to="/">My Arlington -</router-link><router-link to="/apartments"> Apartments &amp; Condos</router-link></h2>
            <div id="blurb">
              <p>

              </p>
              <br/>
            </div>
        </div>
        <div class="layer-page">
            <div class="widget one-third filter-pane">
                <button type="button" class="filter-header" id="mobile-menu" v-show="isMobile || mobileMenu === false" @click="mobileMenu = !mobileMenu" :aria-expanded="mobileMenu ? 'true' : 'false'" aria-controls="filters-and-settings">
                    Filters and Location
                    <svg v-show="!mobileMenu" style="float: right" class="icon" aria-hidden="true" focusable="false"><use xlink:href="#icon-plus"></use></svg>
                    <svg v-show="mobileMenu" style="float: right" class="icon" aria-hidden="true" focusable="false"><use xlink:href="#icon-minus"></use></svg>
                </button>
                <div id="filters-and-settings" v-show="!isMobile || mobileMenu">
                    <div class="filter-container">
                        <button type="button" class="filter-header" @click="filtersToggle" v-show="!isMobile" :aria-expanded="filtersExpanded ? 'true' : 'false'" aria-controls="apartments-filter-list">
                            <span>Filters
                                <svg v-show="filtersExpanded" style="float: right" class="icon" aria-hidden="true" focusable="false"><use xlink:href="#icon-minus"></use></svg>
                                <svg v-show="!filtersExpanded" style="float: right" class="icon" aria-hidden="true" focusable="false"><use xlink:href="#icon-plus"></use></svg>
                                <span style="clear: both; display: block"></span>
                            </span>
                        </button>
                        <div id="apartments-filter-list" class="filterList" v-show="filtersExpanded || mobileMenu">
                            <div class="filter-item filter-category">Type</div>
                            <div class="filter-item">
                                <label class="filter-checkbox-label">
                                <input v-model="typeSelected" :value="'Apartment'" type="checkbox" />
                                <span class="tooltip"> Apartment</span>
                                </label>
                            </div>
                            <div class="filter-item">
                                <label class="filter-checkbox-label">
                                <input v-model="typeSelected" :value="'Condominium'" type="checkbox" />
                                <span class="tooltip"> Condo</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="filter-container">
                        <label for="civicAssociation">Civic Association</label>
                        <br />
                        <div>
                            <select id="civicAssociation" v-model="civicAssocationsSelected">
                                <option value="">Select a civic association</option>
                                <option v-for="ca in civicAssociations" :key="ca.OBJECTID" :value="ca">{{ca.LABEL}}</option>
                            </select>
                        </div>
                        <span v-show="civicAssociationFailure">Unable to load Civic Assocations.</span>
                    </div>

                    <h3>Zoom to Location</h3>
                    <div class="filter-container">
                        <button @click="getCurrentLocation" class="filter-header">Your Current Location</button>
                    </div>
                    <div class="filter-container zoom-container">
                        <label for="addressSearch">Address</label>
                        <br/>
                        <gmap-autocomplete id="addressSearch" ref="autocomplete" @place_changed="placeChanged" placeholder="Enter street address"></gmap-autocomplete>
                    </div>

                    <div class="filter-container">
                      <button class="link filter-header" @click="clearAll">Clear All</button>
                    </div>
                </div>
            </div>
            <div class="widget full-map-pane toggle-window">
                <div style="position: relative; top: 0">
                  <div class="toggle-bar" role="group" aria-label="Map or list">
                    <button type="button" :class="showMap === true ? 'toggle-link' : 'toggle-link active'" :aria-pressed="showMap === true" @click="showMap = true">Map</button>
                    <button type="button" :class="showMap === false ? 'toggle-link' : 'toggle-link active'" :aria-pressed="showMap === false" @click="showMap = false" id="list-link">List</button>
                  </div>
                </div>
                <gmap-map
                    v-show="showMap"
                    :center="mapCenter"
                    :zoom="zoomLevel"
                    :options="mapStyles"
                    id="vue-map-container"
                    aria-label="Map of apartment and condo locations"
                    >

                    <!-- Apartment Shapes -->
                    <!--
                      <gmap-circle :center="apartment" :options="shapeOptions" :radius="32" @click="(e) => shapeClick(apartment, e)"></gmap-circle>
                      -->
                    <gmap-marker v-for="apartment in filteredApartments"
                      :key="apartment.id"
                      :position="apartment"
                      :icon="icon"
                      :options="shapeOptions"
                      @click="(e) => shapeClick(apartment, e)">
                    </gmap-marker>
                    <!-- Common Info Window -->
                    <gmap-info-window
                      :opened="selectedInfoWindowPosition !== null"
                      :position="selectedInfoWindowPosition"
                      @closeclick="infoWindowCloseClick">
                        <div class="info-window">
                            <b v-html="selectedItem.complexName"></b><br/>
                            <span>{{selectedItem.complexTypeName}}</span><br/>
                            <span>{{selectedItem.complexStreetNbrNameText}}</span>
                            <span v-if="selectedItemCivic">
                              <br/><br/>
                              Within the <b>{{selectedItemCivic.civicAssociationName}}</b> civic association.
                              <br/>
                              {{selectedItemCivic.contactTitleName}} - {{selectedItemCivic.contactName}} <br/>
                              {{selectedItemCivic.firstContactEmailText}}
                            </span>
                        </div>
                    </gmap-info-window>

                    <!-- Location Markers -->
                    <gmap-marker v-if="selectedCoordinates" :position="selectedCoordinates" :radius="24"></gmap-marker>
                    <gmap-polygon v-if="civicAssocationsSelected" :path="civicAssocationsSelected.paths" :options="locationOptions"></gmap-polygon>
                </gmap-map>
                <div v-show="!showMap" class="list-pane">
                  <div v-for="apartment in filteredApartments" :key="apartment.id" class="project">
                    <h3 class="h3-list"><span v-if="apartment.complexName" v-html="apartment.complexName"></span><span v-else>Apartment or condo</span></h3>
                    <p class="no-vertical-margin">
                      <span>{{apartment.complexTypeName}}</span><br/>
                      <span>{{apartment.complexStreetNbrNameText}}</span>
                      <br/>
                    </p>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import R from 'ramda';
import geolib from 'geolib';
import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps'
import { mapGetters, mapActions } from 'vuex';

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDIkJCuWTcYkqhKmKQBKgsFvLJYeZxUu4U',
    libraries: 'places',
    v: 'beta'
  }
})

export default {
  name: 'apartments',
  data () {
    return {
      isMobile: false,
      showMap: true,
      mobileMenu: null,
      filtersExpanded: true,
      mapStyles: {styles: [{featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }]}]},
      civicAssocationsSelected: '',
      civicAssociationFailure: false,
      // map properties
      center: {
        lat: 38.8809462,
        lng: -77.099029
      },
      icon: {
        path: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
        fillColor: '#0040FF', // '#015cb9',
        fillOpacity: 1,
        strokeWeight: 0.5,
        strokeColor: '#fff',
        scale: 1,
        anchor: { x: 14, y: 10 } // eslint-disable-line no-undef
      },
      shapeOptions: {
        strokeColor: '#0040FF',
        strokeOpacity: 0.9,
        strokeWeight: 4,
        fillColor: '#0040FF',
        fillOpacity: 0.35,
        zIndex: 2
      },
      locationOptions: {
        strokeColor: '#FF0000',
        strokeOpacity: 0.9,
        fillColor: '#FF0000',
        fillOpacity: 0.35,
        zIndex: 1
      },
      addressPinOptions: {
        strokeColor: '#FF0000',
        strokeOpacity: 0.9,
        fillColor: '#FF0000',
        fillOpacity: 0.9
      },
      selectedCoordinates: null,
      selectedInfoWindowPosition: null,
      selectedItem: {},
      searchText: '',
      typeSelected: []
    }
  },
  computed: {
    ...mapGetters(['apartments', 'civicAssociations']),
    zoomLevel: function () {
      if (!this.selectedCoordinates && !this.civicAssocationsSelected) {
        return 13;
      }
      return 15;
    },
    mapCenter: function () {
      if (this.selectedCoordinates) {
        return this.selectedCoordinates;
      }

      if (this.civicAssocationsSelected) {
        console.log(this.civicAssocationsSelected)
        const civicCenter = geolib.getCenter(this.civicAssocationsSelected.paths);
        civicCenter.lat = Number(civicCenter.latitude);
        civicCenter.lng = Number(civicCenter.longitude);

        return civicCenter;
      }

      return this.center;
    },
    filteredApartments: function () {
      var filterByType = R.filter(f => !this.typeSelected || this.typeSelected.length === 0 || this.typeSelected.indexOf(f.complexTypeName) >= 0);
      var filterByCivic = R.filter(f => !this.selectedCivicInfo || f.civicAssociationKey === this.selectedCivicInfo.civicAssociationKey);

      var sortByTitle = R.sortBy(R.compose(R.toLower, R.prop('complexName')));
      return R.compose(sortByTitle, filterByType, filterByCivic)(this.apartments);
    }
    /* selectedCivicInfo: function () {
      if (this.civicAssocationsSelected !== '') {
        return this.civicInfo.find(f => f.civicAssociationGisId === this.civicAssocationsSelected.id);
      }
    },
    selectedItemCivic: function () {
      if (this.selectedItem) {
        console.log(this.selectedItem)
        return this.civicInfo.find(f => f.civicAssociationKey === this.selectedItem.civicAssociationKey);
      }
    } */
  },
  mounted: function () {
    this.loadApartments();
    this.loadCivicAssociations();

    this.isMobile = window.innerWidth < 600;

    if (this.queryStatus) {
      const split = this.queryStatus.split(',');
      this.statusesSelected = split;
      this.filtersExpanded = true;
    }

    if (this.querySubStatus) {
      const statusSplit = this.querySubStatus.split(',');
      this.subStatusesSelected = statusSplit;
      this.filtersExpanded = true;
    }

    if (this.queryProjectType) {
      const projSplit = this.queryProjectType.split(',');
      console.log('Projects', projSplit);
      var joined = R.innerJoin((record, label) => record.label === label, this.projectTypes);
      var values = R.map(R.prop('value'));

      this.projectTypesSelected = R.compose(values, joined)(projSplit);
      this.filtersExpanded = true;
    }
  },
  watch: {
    statusesSelected () {
      this.infoWindowCheck();
    },
    projectTypesSelected () {
      this.infoWindowCheck();
    }
  },
  methods: {
    ...mapActions(['loadApartments', 'loadCivicAssociations']),
    filtersToggle: function () {
      this.filtersExpanded = !this.filtersExpanded
    },
    clearAll () {
      this.subStatusesSelected = [];
      this.statusesSelected = [];
      this.projectTypesSelected = [];
      this.selectedCoordinates = null;
      this.civicAssocationsSelected = '';
      this.$refs.autocomplete.$refs.input.value = '';
    },
    placeChanged: function (place) {
      this.selectedCoordinates = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() };
    },
    getCurrentLocation: function () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(pos => {
          this.selectedCoordinates = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        }, err => {
          alert('Unable to determine current location at this time.');
          return err;
        });
      }
    },
    shapeClick: function (item, clickEvent) {
      this.selectedItem = item;
      this.selectedInfoWindowPosition = clickEvent.latLng;
    },
    infoWindowCloseClick: function () {
      this.selectedItem = {};
      this.selectedInfoWindowPosition = null;
    },
    infoWindowCheck () {
      if (this.selectedItem && this.selectedItem.id) {
        const ifCheck = R.find(p => p.id === this.selectedItem.id)(this.filteredProjects);
        if (ifCheck === null || ifCheck === undefined) {
          this.selectedItem = {};
          this.selectedInfoWindowPosition = null;
        }
      }
    },
    parentStatusClick (parentStatus) {
      var statusValues = R.map(R.prop('value'), parentStatus.subStatuses);
      statusValues.forEach(s => {
        const i = this.subStatusesSelected.indexOf(s.value);
        if (i >= 0) {
          this.subStatusesSelected.splice(i, 1);
        }
      });
    }
  }
}

</script>

<style lang="scss" scoped>
    .filter-category {
      font-weight: bold;
      font-size: 1.45em;
    }

    .toggle-link {
      cursor: pointer;
      padding: 0 12px;
    }

    .toggle-window {
      border: 2px solid #f1f1f1;
      padding: 8px;
      margin-bottom: 4px;
    }

    #list-link {
      border-left: 2px solid #f1f1f1;
    }

    .toggle-bar {
      padding-bottom: 8px;
      border-bottom: 2px solid #f1f1f1;
    }

    p.no-vertical-margin {
      margin-bottom: 0;
      margin-top: 0;
    }

    .project {
      margin-bottom: 1rem;
    }

.list-pane {
  overflow-y: scroll;
}

@media (max-width: 650px) {
  .list-pane {
    max-height: 80%;
  }
}
</style>



// WEBPACK FOOTER //
// Apartments.vue?72777561